import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';

import { ICrisisActions, IThunkGetCrisisCalls } from '../types';

const onGetCrisisCalls: IThunkGetCrisisCalls = thunk(
  async ({ setCrisisCalls }: Actions<ICrisisActions>, { clinicId }) => {
    const { crisisCalls = [] } = await api.crisis.getCrisisCalls(clinicId).then(r => r.data);

    setCrisisCalls(crisisCalls);

    return { crisisCalls };
  },
);

export default onGetCrisisCalls;
